import { render, staticRenderFns } from "./Proactive.vue?vue&type=template&id=9c04e12a&scoped=true&lang=html&"
import script from "./Proactive.vue?vue&type=script&lang=js&"
export * from "./Proactive.vue?vue&type=script&lang=js&"
import style0 from "./Proactive.vue?vue&type=style&index=0&id=9c04e12a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c04e12a",
  null
  
)

export default component.exports